(function () {
  'use strict';

  var modal = document.querySelector('[data-free-download-modal]');
  if (!modal) return;

  var formWrapper = modal.querySelector('[data-free-download-form-wrapper]');
  var form = modal.querySelector('[data-free-download-form]');
  var emailInput = modal.querySelector('[data-free-download-email]');
  var successEl = modal.querySelector('[data-free-download-success]');

  var currentBeatId = '';
  var currentBeatTitle = '';

  // Open modal — event delegation for Swup compatibility
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-free-download-trigger]');
    if (!trigger) return;

    e.preventDefault();
    currentBeatId = trigger.dataset.beatId || '';
    currentBeatTitle = trigger.dataset.beatTitle || '';

    // Reset state
    form.reset();
    formWrapper.style.display = '';
    successEl.style.display = 'none';

    modal.showModal();
  });

  // Close modal
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-free-download-close]')) {
      modal.close();
    }
  });

  // Close on backdrop click
  modal.addEventListener('click', function (e) {
    if (e.target === modal) modal.close();
  });

  // Submit
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var email = emailInput.value.trim();
    if (!email || !currentBeatId) return;

    var btn = form.querySelector('.free-dl-modal__submit');
    btn.disabled = true;
    btn.textContent = 'Sending...';

    fetch('/api/free-download', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        beatId: currentBeatId,
        beatTitle: currentBeatTitle,
      }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Request failed');
        formWrapper.style.display = 'none';
        successEl.style.display = '';
      })
      .catch(function () {
        btn.textContent = 'Error — Try Again';
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = 'Get Free Download';
      });
  });
})();
